import Gift from '../models/Gift'
import GiftBoxEvents from './GiftBoxEvents'
import giftBoxABI from './GiftBoxABI'

export default class GiftService {
  static get contract () {
    return window.web3.eth.contract(giftBoxABI).at(process.env.CONTRACT_ADDRESS)
  }

  static get (uuid) {
    return new Promise((resolve, reject) => {
      if (!uuid || uuid === '') { reject(new Error()) }

      const response = GiftService
        .contract
        .getGift(
          uuid,
          {},
          (error, result) => {
            if (error) {
              console.error(error)
              reject(error)
            } else if (result) {
              const gift = new Gift(
                result[0],
                window.web3.fromWei(result[1], 'ether'),
                result[2],
                result[3],
                result[4],
                result[5],
                result[6],
                result[7],
                result[8]
              )

              resolve(gift)
            }
          })
    })
  }

  static send (gift) {
    console.log(`Sending gift is ${gift.uuid}`)

    return new Promise((resolve, reject) => {
      const _contract = GiftService.contract

      const onGiftSendEvent = _contract.OnGiftSend({}, { from: gift.senderAddress })
      onGiftSendEvent.watch((error, result) => {
        if (error && !GiftService.isJsonRpcError(error)) {
          console.error(error)
          reject(GiftBoxEvents.OnGiftSend)
          onGiftSendEvent.stopWatching()
        } else if (result && result.args.giftUuid === gift.uuid) {
          console.log(result)
          resolve(gift)
          onGiftSendEvent.stopWatching()
        }
      })

      GiftService.handleErrorEvent(_contract.IsGiftAlreadyExist({ giftUuid: gift.uuid }), GiftBoxEvents.IsGiftAlreadyExist, reject, gift.uuid)
      GiftService.handleErrorEvent(_contract.OnValueUnderCommission({ giftUuid: gift.uuid }), GiftBoxEvents.OnValueUnderCommission, reject, gift.uuid)

      _contract
        .sendGift(
          gift.uuid,
          gift.receiverAddress,
          gift.message,
          gift.senderName,
          gift.receiverName,
          {
            from: gift.senderAddress,
            value: window.web3.toWei(String(gift.etherPrice), 'ether')
          },
          (error, result) => {
            if (error) {
              console.error(error)
              reject(error)
            } else {
              console.log(result)
            }
          })
    })
  }

  static receive (gift) {
    console.log(`Receiving gift is ${gift.uuid}`)

    return new Promise((resolve, reject) => {
      const _contract = GiftService.contract

      const onGiftReceived = _contract.OnGiftReceived({}, { from: gift.receiverAddress })
      onGiftReceived.watch((error, result) => {
        if (error && !GiftService.isJsonRpcError(error)) {
          console.error(error)
          reject(GiftBoxEvents.OnGiftReceived)
          onGiftReceived.stopWatching()
        } else if (result && result.args.giftUuid === gift.uuid) {
          console.log(result)
          resolve(gift)
          onGiftReceived.stopWatching()
        }
      })

      GiftService.handleErrorEvent(_contract.WasGiftCancelled({}, { from: gift.receiverAddress }), GiftBoxEvents.WasGiftCancelled, reject, gift.uuid)
      GiftService.handleErrorEvent(_contract.WasGiftReceived({}, { from: gift.receiverAddress }), GiftBoxEvents.WasGiftReceived, reject, gift.uuid)

      _contract
        .receiveGift(
          gift.uuid,
          {
            from: gift.receiverAddress
          },
          (error, result) => {
            if (error) {
              console.error(error)
              reject(error)
            } else {
              console.log(result)
            }
          }
        )
    })
  }

  static cancel (gift) {
    console.log(`Cancelling gift is ${gift.uuid}`)
    
    return new Promise((resolve, reject) => {
      if (!gift || gift.uuid === '') { reject(new Error()) }

      const _contract = GiftService.contract

      const onGiftCancelled = _contract.OnGiftCancelled({}, { from: gift.receiverAddress })
      onGiftCancelled.watch((error, result) => {
        if (error && !GiftService.isJsonRpcError(error)) {
          console.error(error)
          reject(GiftBoxEvents.OnGiftCancelled)
          onGiftCancelled.stopWatching()
        } else if (result && result.args.giftUuid === gift.uuid) {
          console.log(result)
          resolve(gift)
          onGiftCancelled.stopWatching()
        }
      }) 

      _contract
        .cancelGift(
          gift.uuid,
          { from: gift.senderAddress },
          (error, result) => {
            if (error) {
              console.error(error)
              reject(error)
            } else {
              console.log(result)
            }
          }
        )
    })
  }

  static sendMail (gift, mailAddress) {
    return new Promise((resolve, reject) => {
      // TODO:
    })
  }

  static handleErrorEvent (event, eventName, reject, giftUuid) {
    event.watch((error, result) => {
      console.error(error)
      console.log(result)

      if ((error && !GiftService.isJsonRpcError(error)) ||
          (result && result.args.giftUuid === giftUuid)) {
        event.stopWatching()
        reject(eventName)
      }
    })
  }

  static isJsonRpcError (error) {
    return error.message.includes('Error: [ethjs-rpc] rpc error with payload')
  }
}



// WEBPACK FOOTER //
// ./src/services/GiftService.js